import { getConfigForImportedTest, getConfigForMeasuredTest, getConfigForTest } from 'Components/Worksheets/Config';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import { default as qestIds } from '../../../QestIds';
import getMeasuredUsingConfig from '../../measuredUsingConfig';
import getDerivedFromMeasurementsConfig from './derivedFromMeasurementsConfig';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      ...getConfigForImportedTest(
        qestIds.psdSieveAnalysis.AS_1289_3_6_1.Rev2009,
        `${prefix}.SamplePreparation.AssociatedPercentagePassing`,
        [
          qestIds.psdSieveAnalysis.AS_1289_3_6_3,
          qestIds.psdSieveAnalysis.AS_1289_3_6_1.RevOriginal,
          qestIds.psdSieveAnalysis.AS_1289_3_6_1.RevOriginal2,
          qestIds.psdSieveAnalysis.AS_1289_3_6_1.Reduced,
        ]
      ),
      [`${prefix}.SamplePreparation.PercentPassing`]: { format: { nearest: 0.1 } },
      [`${prefix}.SamplePreparation.DryingTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.SamplePreparation.AssociatedPercentagePassing.ExternalTest.Results.PercentagePassing_425_Sieve`]: {
        format: { nearest: 1 },
      },
      ...getConfigForMeasuredTest(
        qestIds.linearShrinkage.AS_1289_5_4_1.rev2008,
        'data.LinearShrinkage.EmbeddedLinearShrinkage'
      ),
      ...getConfigForTest(
        qestIds.moistureContent.AS_1289_2_1_1.rev2005,
        'data.LiquidLimit.Trials.MoistureDetermination'
      ),
      [`${prefix}.LiquidLimit.LiquidLimit`]: { format: { nearest: 1 } },
      [`${prefix}.LiquidLimit.Trials.Drops`]: { format: { nearest: 1 } },
      [`${prefix}.LiquidLimit.Trials.Drops2`]: { format: { nearest: 1 } },
      [`${prefix}.LiquidLimit.Trials.NumberOfDrops`]: { format: { nearest: 1 } },
      [`${prefix}.LiquidLimit.Trials.LiquidLimit`]: { format: { nearest: 1 } },
      [`${prefix}.PlasticLimit.Trials.Drops`]: { format: { nearest: 1 } },
      [`${prefix}.PlasticLimit.DryingTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.LiquidLimit.DryingTemperature`]: { uom: '°C', format: { nearest: 1 } },
      ...getConfigForTest(
        qestIds.moistureContent.AS_1289_2_1_1.rev2005,
        'data.PlasticLimit.Trials.MoistureDetermination'
      ),
      [`${prefix}.Results.LiquidLimit`]: { format: { nearest: 1 } },
      [`${prefix}.Results.PlasticLimit`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.PlasticityIndex`]: { format: { nearest: 1 } },
      [`${prefix}.Results.LinearShrinkage`]: { format: { nearest: 0.5 } },
      [`${prefix}.Results.WeightedPlasticityIndex`]: { format: { nearest: 1 } },
      [`${prefix}.LiquidLimit.CuringDuration`]: { uom: 'h', format: { nearest: 0.1 } },
      ...getConfigForMeasuredTest(
        qestIds.moistureContent.AS_1289_2_1_1.rev2005,
        'data.LiquidLimit.EmbeddedWaterContent'
      ),
    },
    getLabelConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    getMeasuredUsingConfig(prefix),
    {
      [`${prefix}.PlasticLimit.Balance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.PlasticLimit.DryMassBalance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.LiquidLimit.Balance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.LiquidLimit.DryMassBalance`]: { defaultReadability: 0.01, defaultUom: 'g' },
    }
  );

export default {
  [qestIds.atterbergLimit.AS_1289_3_1_1or3_2_1or3_3_1.rev2009]: getConfig,
  [qestIds.atterbergLimit.AS_1289_3_1_2or3_2_1or3_3_1.rev2009]: getConfig,
  [qestIds.atterbergLimit.AS_1289_3_1_1or3_2_1or3_3_1or3_4_1.rev2009]: getConfig,
  [qestIds.atterbergLimit.AS_1289_3_1_2or3_2_1or3_3_1or3_4_1.rev2009]: getConfig,
};
